import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=7c9b667e&"
import script from "./AddCompany.vue?vue&type=script&lang=js&"
export * from "./AddCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=7c9b667e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c9b667e')) {
      api.createRecord('7c9b667e', component.options)
    } else {
      api.reload('7c9b667e', component.options)
    }
    module.hot.accept("./AddCompany.vue?vue&type=template&id=7c9b667e&", function () {
      api.rerender('7c9b667e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/customers/Add/AddCompany.vue"
export default component.exports